import { render, staticRenderFns } from "./SecondarySidebar.vue?vue&type=template&id=7dd10a1f&"
import script from "./SecondarySidebar.vue?vue&type=script&lang=js&"
export * from "./SecondarySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports